import { Select, SelectOption } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  selectUploadSortOrder,
  setUploadSortOrder,
  UploadSortOrderEnum,
} from '../../scansSlice';

const UploadSortOrderDropdown: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const value = useAppSelector(selectUploadSortOrder);

  const uploadOrderOptions: SelectOption<UploadSortOrderEnum>[] = useMemo(
    () => [
      { value: UploadSortOrderEnum.newest, label: t('Newest') },
      {
        value: UploadSortOrderEnum.percentComplete,
        label: `${t('Completion')} %`,
      },
    ],
    [t]
  );

  const handleChange = (value: UploadSortOrderEnum) => {
    dispatch(setUploadSortOrder(value));
  };

  return (
    <Select
      options={uploadOrderOptions}
      value={value}
      onChange={handleChange}
      fullWidth
    />
  );
};

export default UploadSortOrderDropdown;
